module.exports = __webpack_public_path__ + "static/media/Group.be8f9594.png";